const Types = {
  SET_LOADER: "SET_LOADER",
  SET_THEME: "SET_THEME",
  SET_USERS: "SET_USERS",
  SET_TEST_KITS: "SET_TEST_KITS",
  SET_TEST_KIT_DETAIL: "SET_TEST_KIT_DETAIL",
  SET_DOCTORS: "SET_DOCTORS",
  SET_DOCTOR_DETAILS: "SET_DOCTOR_DETAILS",
  SET_PATIENT_DETAILS: "SET_PATIENT_DETAILS",
  SET_PATIENTS: "SET_PATIENTS",
  SET_CHAT_LIST: "SET_CHAT_LIST",
  SET_MORE_CHAT_LIST: "SET_MORE_CHAT_LIST",
  SET_CHAT_HISTORY: "SET_CHAT_HISTORY",
  CLEAR_CHAT_LIST: "CLEAR_CHAT_LIST",
  CLEAR_CHAT_HISTORY: "CLEAR_CHAT_HISTORY",
  SET_CHAT_UNREAD_COUNT: "SET_CHAT_UNREAD_COUNT",
  SET_KITS_PENDING_TESTING: "SET_KITS_PENDING_TESTING",
  SET_KITS_PENDING_RESULT_UPLOAD: "SET_KITS_PENDING_RESULT_UPLOAD",
  SET_HOME_PAGE_STATS: "SET_HOME_PAGE_STATS",
  SET_KITS_PENDING_SAMPLE_COLLECTION: "SET_KITS_PENDING_SAMPLE_COLLECTION",
  SET_TEST_KIT_VISUALIZATIONS: "SET_TEST_KIT_VISUALIZATIONS",
  SET_QUESTIONNAIRES: "SET_QUESTIONNAIRES",
  SET_QUESTIONNAIRE_DETAIL: "SET_QUESTIONNAIRE_DETAIL",
  SET_QUESTIONNAIRE_DETAIL_BY_TEST_KIT: "SET_QUESTIONNAIRE_DETAIL_BY_TEST_KIT",
  SET_MEDICAL_HISTORY: "SET_MEDICAL_HISTORY",
};

export default Types;
